import axios from "axios";
import { base_url } from "../../../utils/baseUrl";



const getMembers = async (token) => {
  
  const response = await axios.get(`${base_url}members/getMember`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
      Accept: "application/json",
    }
  });
 
  return response.data;
  
};
const createMember = async (values) => {
  const token = values.token;
  
  const response = await axios.post(
    `${base_url}members/register`,
    values, // Pass form data directly
    {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        Accept: "application/json",
      },
    }
  );

  return response.data;
};
const createMemberbulk = async (values) => {
  const token = values.get("token");
  const response = await axios.post(
    `${base_url}members/addMemberBulk`,
    values, // Pass form data directly
    {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        Accept: "application/json",
      },
    }
  );

  return response.data;
};

const updateMember = async (values) => {
  
  const response = await axios.put(
    `${base_url}members/editMember/${values.id}`,
    values.NewsData,

  );

  return response.data;
};

const getMember = async (id) => {
  const response = await axios.get(`${base_url}members/getById/${id}`);

  return response.data;
};

const deleteMember = async (id) => {
  const response = await axios.delete(`${base_url}members/deleteMember/${id}`);

  return response.data;
};
const MemberService = {
  createMemberbulk,
  getMembers,
  createMember,
  getMember,
  updateMember,
  deleteMember,
};

export default MemberService;
